<table *ngIf="dataSource.data.length > 0" mat-table [dataSource]="dataSource" class="mat-elevation-z8" data-testid="table"  class="table-container">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
          color= "primary"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? checkBoxClicked(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
          color= "primary"
        >
        </mat-checkbox>
      </td>
    </ng-container>
  
    <!-- Position Column -->
    <ng-container matColumnDef="airTime">
      <th mat-header-cell *matHeaderCellDef>Air Time</th>
      <td mat-cell *matCellDef="let element">{{element.airTime}}</td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let element">{{element.type}}</td>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="eventName">
      <th mat-header-cell *matHeaderCellDef>Event Name</th>
      <td mat-cell *matCellDef="let element">{{element.eventName}}</td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duration</th>
      <td mat-cell *matCellDef="let element">{{element.durationInSeconds | formatFancyTime}}</td>
    </ng-container>
  
    <!-- Download Column -->
    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef></th>
      <td data-testid="downloadButton" mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
        <button mat-stroked-button *ngIf="!element.isLoading; else withoutLink" [disabled]="element.isDownloadDisabled"
            (click)="openConfirmationDialog(element)"> {{element.nameButton}}
        </button>
    </td>
    <ng-template #withoutLink>
        Processing...
        <mat-progress-bar data-testid="processing" mode="indeterminate"></mat-progress-bar>
    </ng-template>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns;"
      [class.row-selected]="selection.isSelected(row)"
      (click)="checkBoxClicked(row)"
    ></tr>
  </table>

  
  <mat-card class="no-results">
    <app-sia-loading [show]="loading | async"></app-sia-loading>
    <div *ngIf="dataSource.data.length === 0 && (loading | async) === false">No Metadata available</div>
  </mat-card>
  
